// extracted by mini-css-extract-plugin
module.exports = {"root":"drawer-icon-close_root__nOGt4"};